import getInvoiceReminderNameFrom from "../../invoiceReminders/getInvoiceReminderNameFrom"

const getSubjectForInvoiceReminder = (reminderStepNumber?: number | null, header?: string | null) => {
  return `${getInvoiceReminderNameFrom(reminderStepNumber)} ${header}`
}

export default getSubjectForInvoiceReminder